// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"82edea4b","264":"a6c8bf81","290":"ef28b177","358":"e1a3f6c1","420":"705f6d72","571":"17b32d5f","672":"f6b63fa1"}[chunkId] + ".chunk.js";
};